// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================React Leaflet===================
import { MapContainer, TileLayer } from 'react-leaflet';

// ==================React Hooks===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// ==================Other Library===================
import classnames from 'classnames';

// ===================ACTIONS======================
import { toggleBackgroundImage } from '../../../actions/site';
import { setMultipleMarker, setSaveMarkerComponent } from '../../../actions/multipleMetadata';

// ====================Component==================
import Markers from '../../Site/MapLeaflet/Markers';
import UseMap from './UseMap';

function MultipleMetadataMap() {
  // =================HOOKS=================
  const dispatch = useDispatch();
  const center = useSelector((state) => state.site.map.center);
  const mapURL = useSelector((state) => state.site.map.mapURL);
  const buttonImage = useSelector((state) => state.site.map.miniatureBackground);
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const multipleMarker = useSelector((state) => state.multipleMetadata.dataMultiple.multipleMarker);
  const markerComponent = useSelector(
    (state) => state.multipleMetadata.dataMultiple.markerComponent,
  );
  const multipleMetadataArray = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleMetadataArray,
  );

  // ================Handler=======================
  function handleBackgroundImage() {
    dispatch(toggleBackgroundImage());
  }

  // ================classnames=====================

  const miniatureBackground = classnames('mapbuttonid', { 'mapbuttonid--road': buttonImage });

  let markerComponents = [];

  // =============UseEffect==============
  // when multipleMetadata update creaton of  corresponding marker on the map
  useEffect(() => {
    if (multipleMetadataArray.length !== 0) {
      markerComponents = multipleMetadataArray.map((marker) => (
        <Markers
          key={marker.marker_long_name}
          shortName={marker.marker}
          longName={marker.marker_long_name}
          lon={marker.location.coordinates.lon}
          lat={marker.location.coordinates.lat}
          alt={marker.location.coordinates.altitude}
          installDate={marker.date_from}
          endDate={marker.date_to}
          country={marker.location.country.name}
          network={marker.network.name}
        />
      ));
      dispatch(setSaveMarkerComponent(markerComponents));
    }
  }, [multipleMetadataArray]);

  useEffect(() => {
    if (markerComponent.length !== 0) {
      dispatch(setMultipleMarker(true));
    }
  }, [markerComponent]);

  return (
    <MapContainer
      center={center}
      zoom={3}
      minZoom={2}
      style={{ width: '100%', height: '100%' }}
      className="multipleMetadataMap"
      gestureHandling
      scrollWheelZoom={false}
    >
      <button className={`${miniatureBackground}`} aria-label="background_image" type="submit" onClick={handleBackgroundImage} />

      <TileLayer
        url={mapURL}
        attribution="zoom: CTRL+SCROLL"
      />
      {(loadingMap === false && multipleMarker === true)
      && markerComponent}
      <UseMap />
    </MapContainer>
  );
}

export default MultipleMetadataMap;
